import React, { useRef, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

/**
 * 弹幕渲染层
 * - Canvas 绘制从右到左滚动的弹幕
 * - 彩色文字
 * - 自动清理过期弹幕
 */
function Danmaku() {
  const canvasRef = useRef(null);
  const danmakus = useSelector((state) => state.chat.danmakus);
  const animRef = useRef(null);
  const bulletsRef = useRef([]);

  // 将新弹幕添加到渲染列表
  useEffect(() => {
    if (danmakus.length > 0) {
      const latest = danmakus[danmakus.length - 1];
      // 避免重复
      if (!bulletsRef.current.find((b) => b.id === latest.id)) {
        const canvas = canvasRef.current;
        bulletsRef.current.push({
          id: latest.id || Date.now(),
          text: latest.content,
          color: latest.color || '#ffffff',
          x: canvas ? canvas.width : 1200,
          y: Math.random() * (canvas ? canvas.height - 30 : 200),
          speed: 2 + Math.random() * 2,
        });
      }
    }
  }, [danmakus]);

  // 动画循环
  const animate = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    bulletsRef.current.forEach((bullet) => {
      ctx.font = 'bold 20px sans-serif';
      ctx.fillStyle = bullet.color;
      ctx.shadowColor = 'rgba(0,0,0,0.5)';
      ctx.shadowBlur = 2;
      ctx.fillText(bullet.text, bullet.x, bullet.y);
      bullet.x -= bullet.speed;
    });

    // 移除飞出屏幕的弹幕
    bulletsRef.current = bulletsRef.current.filter((b) => b.x > -300);

    animRef.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    animRef.current = requestAnimationFrame(animate);
    return () => {
      if (animRef.current) cancelAnimationFrame(animRef.current);
    };
  }, [animate]);

  // 调整 canvas 尺寸
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const resize = () => {
      canvas.width = canvas.parentElement?.offsetWidth || 800;
      canvas.height = canvas.parentElement?.offsetHeight || 400;
    };
    resize();
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 pointer-events-none"
      style={{ zIndex: 10 }}
    />
  );
}

export default Danmaku;
